import { FC, PropsWithChildren } from 'react';
import zhCN from 'antd/locale/zh_CN';
import ConfigProvider from 'antd/es/config-provider';

const AntdProvider: FC<PropsWithChildren> = ({ children }) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#f32640ff',
        },
      }}
      locale={zhCN}
    >
      {children}
    </ConfigProvider>
  );
};

export default AntdProvider;
